export default "__VITE_ASSET__Dq$feM5M__"